/**
 * Node visual para "Pular" - permite pular para outro node no fluxo
 * Não possui saída (output handle) pois pula diretamente para o node destino
 * Inclui toolbar flutuante ao selecionar
 */

import { Handle, Position, NodeProps } from '@xyflow/react';
import { CornerDownRight, AlertCircle } from 'lucide-react';
import { FlowNodeData, GotoConfig } from '@/types/flows';
import { FlowNodeToolbar } from './FlowNodeToolbar';

/**
 * Componente visual do node Pular (GoTo)
 */
export function GotoNode({ data, id, selected }: NodeProps) {
  const nodeData = data as FlowNodeData;
  const config = nodeData.config as GotoConfig;
  const hasTarget = !!config?.target_node_id;
  
  // Callbacks injetados via FlowCanvas
  const onEdit = (nodeData as any).onEdit;
  const onDuplicate = (nodeData as any).onDuplicate;
  const onDelete = (nodeData as any).onDelete;
  const onTestFromHere = (nodeData as any).onTestFromHere;

  return (
    <div
      className="relative min-w-[180px] max-w-[220px] p-3 rounded-lg border-2 border-violet-500/50 bg-card shadow-sm"
    >
      {/* Toolbar flutuante */}
      <FlowNodeToolbar
        nodeId={id}
        nodeType={nodeData.type}
        onEdit={onEdit}
        onDuplicate={onDuplicate}
        onDelete={onDelete}
        onTestFromHere={onTestFromHere}
        isVisible={selected}
      />
      
      {/* Handle de entrada */}
      <Handle
        type="target"
        position={Position.Top}
        className="!bg-violet-500 !w-3 !h-3"
      />

      {/* Cabeçalho */}
      <div className="flex items-center gap-2 mb-2">
        <div className="p-1.5 rounded bg-violet-500">
          <CornerDownRight className="h-4 w-4 text-white" />
        </div>
        <span className="font-medium text-sm">{nodeData.config?.nickname || 'Pular para'}</span>
      </div>

      {/* Conteúdo */}
      {hasTarget ? (
        <div className="space-y-1">
          <code className="text-xs bg-violet-100 dark:bg-violet-900/30 px-2 py-1 rounded block truncate text-violet-700 dark:text-violet-300">
            {config.target_node_id}
          </code>
          {config.target_node_label && (
            <p className="text-xs text-muted-foreground truncate">
              ({config.target_node_label})
            </p>
          )}
        </div>
      ) : (
        <div className="flex items-center gap-1 text-xs text-destructive">
          <AlertCircle className="h-3 w-3" />
          <span>Node destino não configurado</span>
        </div>
      )}

      {/* Nota: NÃO há handle de saída - o node pula diretamente */}
      <p className="text-[10px] text-muted-foreground mt-2 italic">
        * Não requer conexão de saída
      </p>
    </div>
  );
}
